export const generateBackground = ({
  gridWidth,
  gridHeight,
  rowHeight,
  margin,
  columns,
  isEditing,
  gridColor = '#E9EBF4',
}) => {
  const cellWidth = gridWidth / columns;
  const cellHeight = rowHeight;

  const rows = Math.floor(gridHeight / rowHeight);

  const rectangles = [];

  if (!rows || !columns) {
    return '';
  }

  Array.from(Array(rows).keys()).forEach((row) => {
    Array.from(Array(columns).keys()).forEach((column) => {
      const width = Math.floor(cellWidth - margin) - 4;
      const height = cellHeight;

      const x = Math.ceil(column * cellWidth + column);
      const y = row * (cellHeight + margin);

      rectangles.push(
        `<rect fill="${
          isEditing ? gridColor : 'transparent'
        }" x="${x}" y="${y}" width="${width}" height="${height}" rx="6" ry="6" />`
      );
    });
  });

  // console.log(rectangles);

  const svg = [
    `<svg xmlns="http://www.w3.org/2000/svg" class="grid-placeholder" width="${gridWidth}" height="${
      rows * rowHeight + (margin * rows + 1)
    }">`,
    ...rectangles,
    `</svg>`,
  ].join('');

  // console.log(svg);

  return `url("data:image/svg+xml;utf8,${encodeURIComponent(svg)}")`;
};
